import './InformationModal.scss';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_InfoModal } from '../../../../../../design/modals/infoModal/S_InfoModal';

interface IProps {
  show: boolean;
  onHide: () => void;
}

export const InformationModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show, onHide } = props;
  return (
    <S_InfoModal
      buttonText={t('ok')}
      toggle={onHide}
      onClick={onHide}
      headerText={t('new.projects.details.export_data.export_modal.modal_header')}
      isOpen={show}
      className='export-information-modal'
    >
      <div className='export-information-modal-content'>
        {t('new.projects.details.export_data.export_modal.modal_body')} <FontAwesomeIcon icon={faBell} />
      </div>
    </S_InfoModal>
  );
});
